import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { listBlog } from "../lib/api";

const CATEGORIES = ["All", "Philosophy", "Style Guides", "Fabric & Craftsmanship"];

export default function BlogIndex() {
  const [posts, setPosts] = useState([]);
  const [category, setCategory] = useState("All");

  useEffect(() => {
    listBlog(category === "All" ? null : category).then(setPosts);
  }, [category]);

  const [featured, ...rest] = posts;

  return (
    <div className="max-w-7xl mx-auto px-6 md:px-12 py-12 md:py-20" data-testid="blog-index">
      <div className="text-center mb-14 md:mb-20">
        <p className="eyebrow">The Asvasa Journal</p>
        <h1 className="font-serif-display text-5xl md:text-7xl mt-4">
          Notes on cloth, culture,<br />and quiet dressing.
        </h1>
        <p className="text-[#4A4A4A] mt-6 max-w-2xl mx-auto">
          Style guides, studio dispatches, and slow reads on Indian menswear — published monthly, never rushed.
        </p>
      </div>

      {/* Category filter */}
      <div className="flex flex-wrap justify-center gap-2 md:gap-3 mb-14 pb-8 border-b border-[#a89e80]">
        {CATEGORIES.map((c) => (
          <button
            key={c}
            onClick={() => setCategory(c)}
            className={`px-5 py-2.5 text-[11px] tracking-[0.22em] uppercase transition-colors ${
              category === c
                ? "bg-[#1A1A1A] text-[#c3ba9e]"
                : "text-[#4A4A4A] hover:text-[#1A1A1A]"
            }`}
            data-testid={`blog-filter-${c.replace(/\s+/g, "-").toLowerCase()}`}
          >
            {c}
          </button>
        ))}
      </div>

      {/* Featured */}
      {featured && (
        <Link to={`/blog/${featured.slug}`} className="group block mb-16" data-testid={`blog-featured-${featured.slug}`}>
          <div className="grid md:grid-cols-[1.5fr_1fr] gap-8 md:gap-12 items-center">
            <div className="aspect-[5/4] overflow-hidden bg-[#b8af92] order-2 md:order-1">
              <img src={featured.cover} alt={featured.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-[1400ms]" />
            </div>
            <div className="order-1 md:order-2">
              <p className="eyebrow text-[#1A1A1A]">Featured · {featured.category}</p>
              <h2 className="font-serif-display text-4xl md:text-5xl mt-4 leading-[1.05] group-hover:text-[#1A1A1A] transition-colors">
                {featured.title}
              </h2>
              <p className="text-[#4A4A4A] mt-5 text-[15px] leading-relaxed">{featured.excerpt}</p>
              <div className="flex items-center gap-4 mt-6 text-xs text-[#7A7A7A] tracking-wider">
                <span>{featured.author}</span>
                <span>·</span>
                <span>{featured.read_minutes} min read</span>
              </div>
              <span className="inline-flex items-center gap-2 mt-6 text-[11px] tracking-[0.28em] uppercase text-[#1A1A1A] link-underline">
                Read the story <ArrowRight size={14} />
              </span>
            </div>
          </div>
        </Link>
      )}

      {/* Grid */}
      <div className="grid md:grid-cols-3 gap-10 md:gap-12">
        {rest.map((p) => (
          <Link key={p.slug} to={`/blog/${p.slug}`} className="group block" data-testid={`blog-card-${p.slug}`}>
            <div className="aspect-[4/5] overflow-hidden bg-[#b8af92]">
              <img src={p.cover} alt={p.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-[1200ms]" loading="lazy" />
            </div>
            <p className="eyebrow text-[#1A1A1A] mt-5">{p.category}</p>
            <h3 className="font-serif-display text-2xl mt-2 leading-tight group-hover:text-[#1A1A1A] transition-colors">
              {p.title}
            </h3>
            <p className="text-sm text-[#4A4A4A] mt-2 line-clamp-2">{p.excerpt}</p>
            <p className="text-[11px] text-[#7A7A7A] mt-4 tracking-wider">
              {p.author} · {p.read_minutes} min read
            </p>
          </Link>
        ))}
      </div>

      {posts.length === 0 && (
        <p className="text-center text-[#7A7A7A] py-20">No stories in this category yet.</p>
      )}
    </div>
  );
}
